<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="实验室名称" name="name">
                <a-input v-model:value="searchForm.name" placeholder="请输入实验室名称"/>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
            <template #level="{text}">
                <a-tag>
                    <dict-render :dict-obj="dictObjs['laboratory_level']" :text="text"></dict-render>
                </a-tag>
            </template>
            <template #action="{record}">
                <div class="table-row-operations">
                    <a @click="onEdit(record)">编辑</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
</template>

<script>
import AddOrEditModal from "./components/AddOrEditModal";
import {dictMixin, tableListMixin} from "@/mixins";
import {ScientificApi} from "@/api/innovationService";
import DictRender from "@/components/other/DictRender";
import {defaultDateCustomRender} from "@/utils/customRender";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {title: "实验室名称", dataIndex: "name", key: "name"},
    // {title: "企业", dataIndex: "companyName", key: "companyName"},
    {title: "级别", dataIndex: "level", key: "level",slots: {customRender: "level"}},
    {title: "认定时间", dataIndex: "attestationTime", key: "attestationTime",customRender:defaultDateCustomRender},
    {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "index",
    mixins: [tableListMixin, dictMixin],
    components: {
        AddOrEditModal,
        DictRender
    },
    data() {
        return {
            dictNames: 'laboratory_level',
            columns,
            queryParamFixed: {type:"1"},
            listUrl: ScientificApi.pageList,
            listKeyField: "id",
            deleteUrl: ScientificApi.remove
        }
    },
    methods: {
        onCloseModel(){
            this.loadData(1)
        },
        onAdd() {
            this.onShowModal('modal',{type:"1"});
        },
        onEdit(record) {
            this.getAction({
                url: ScientificApi.detail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },
    }
}
</script>

<style scoped>

</style>
